<template>
  <el-dialog :title="dialogTitle" :visible.sync="visible" width="620px" :close-on-click-modal="false" :before-close="handleClose">
    <el-form ref="form" :model="form" :rules="rules" label-position="top">
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item :label="$t('feeTab.feeName')" prop="feeItem">
            <BjSelectLov v-model="form.feeItem" :placeholder="$t('feeTab.feeName')" :option-list="feeNameOptions" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('feeTab.settlementParty')" prop="cusId">
            <BjSelectLov v-model="form.cusId" :placeholder="$t('feeTab.settlementParty')" :option-list="settlementPartyOptions" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('feeTab.billingUnit')" prop="chargeUnit">
            <BjSelectLov v-model="form.chargeUnit" :placeholder="$t('feeTab.billingUnit')" :option-list="chargeUnitOptions" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('feeTab.settlementCurrency')" prop="quotationCurrency">
            <BjSelectLov v-model="form.quotationCurrency" :placeholder="$t('feeTab.settlementCurrency')" :option-list="currencyOptions" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('feeTab.settlementUnitPrice')" prop="unitPrice">
            <el-input-number v-model="form.unitPrice" :placeholder="$t('feeTab.settlementUnitPrice')" class="full-width" :controls="false" :precision="4" :step="0.0001" :min="0.0001" :max="999999.9999" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('feeTab.quantity')" prop="settlementNum">
            <el-input-number v-model="form.settlementNum" :placeholder="$t('feeTab.quantity')" class="full-width" :controls="false" :precision="3" :step="0.001" :min="0.001" :max="99999.999" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('feeTab.trackingNumber')" prop="trackingNumber">
            <el-input v-model.trim="form.trackingNumber" :maxlength="20" show-word-limit :placeholder="$t('inputText')" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('feeTab.packageNo')" prop="packageNo">
            <el-input v-model.trim="form.packageNo" :maxlength="20" show-word-limit :placeholder="$t('inputText')" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('feeTab.remark')" prop="remark">
            <el-input v-model.trim="form.remark" type="textarea" :rows="4" :maxlength="500" show-word-limit :placeholder="$t('inputText')" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">{{ $t('cancelText') }}</el-button>
      <el-button type="primary" :loading="saving" @click="handleSave">{{ $t('saveText') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { logisticApi } from '@/api';

const emptyForm = () => ({
  id: null,
  feeItem: null,
  cusId: null,
  chargeUnit: null,
  quotationCurrency: null,
  unitPrice: undefined,
  settlementNum: undefined,
  trackingNumber: '',
  packageNo: '',
  remark: '',
});

export default {
  name: 'FeeFormDialog',
  props: {
    feeNameOptions: {
      type: Array,
      default: () => [],
    },
    chargeUnitOptions: {
      type: Array,
      default: () => [],
    },
    outerOrderNo: {
      type: String,
      default: '',
    },
    type: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      visible: false,
      saving: false,
      openType: 'add',
      form: emptyForm(),
      settlementPartyOptions: [],
      currencyOptions: [
        { label: 'AUD', value: 'AUD' },
        { label: 'CNY', value: 'CNY' },
        { label: 'USD', value: 'USD' },
      ],
      rules: {
        feeItem: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        cusId: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        chargeUnit: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        quotationCurrency: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        unitPrice: [
          { required: true, message: this.$t('inputText'), trigger: 'blur' },
          { type: 'number', min: 0.0001, max: 999999.9999, message: this.$t('feeTab.numberRange', { max: '999999.9999' }), trigger: 'blur' },
        ],
        settlementNum: [
          { required: true, message: this.$t('inputText'), trigger: 'blur' },
          { type: 'number', min: 0.001, max: 99999.999, message: this.$t('feeTab.numberRange', { max: '99999.999' }), trigger: 'blur' },
        ],
      },
    };
  },
  computed: {
    dialogTitle() {
      return this.openType === 'edit' ? this.$t('feeTab.editFee') : this.$t('feeTab.addFee');
    },
  },
  methods: {
    open(row) {
      this.openType = row ? 'edit' : 'add';
      this.form = this.buildForm(row);
      this.visible = true;
      this.getOrderQuatePackage();
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate();
      });
    },
    buildForm(row) {
      if (!row) return emptyForm();
      const form = JSON.parse(JSON.stringify(row));
      return {
        ...emptyForm(),
        id: form.id,
        feeItem: this.getOptionValue(form.feeItem, this.feeNameOptions),
        cusId: form.cusId,
        chargeUnit: this.getOptionValue(form.chargeUnit, this.chargeUnitOptions),
        quotationCurrency: form.quotationCurrency,
        unitPrice: form.unitPrice,
        settlementNum: form.settlementNum,
        trackingNumber: form.trackingNumber,
        packageNo: form.packageNo,
        remark: form.remark,
      };
    },
    getOptionValue(value, options) {
      const item = options.find(option => option.value == value);
      return item ? item.value : value;
    },
    getOrderQuatePackage() {
      if (!this.outerOrderNo) {
        this.settlementPartyOptions = [];
        return;
      }
      logisticApi.getOrderQuatePackage(this.outerOrderNo).then(res => {
        const list = Array.isArray(res) ? res : [];
        this.settlementPartyOptions = list.map(item => ({
          label: item.cusName,
          value: item.cusId,
        }));
      });
    },
    handleSave() {
      this.$refs.form.validate(valid => {
        if (!valid) return;
        const API = this.openType === 'edit' ? logisticApi.editOrderQuateCost : logisticApi.addOrderQuateCost;
        const API_DATA = {
          ...this.form,
          outerOrderNo: this.outerOrderNo,
          type: this.type,
        };
        this.saving = true;
        API(API_DATA)
          .then(res => {
            if (res && res.failed) return;
            this.$message.success(this.$t('toast.operationSuccessText'));
            this.$emit('saved');
            this.openType = 'add';
            this.handleClose();
          })
          .finally(() => {
            this.saving = false;
          });
      });
    },
    handleClose() {
      this.visible = false;
      this.resetForm();
    },
    resetForm() {
      this.$refs.form && this.$refs.form.resetFields();
      this.form = emptyForm();
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.full-width {
  width: 100%;
}
</style>
